class AdLayer {

    constructor($rootScope, $builderService, AssetService) {
        
        this.$rootScope = $rootScope;
        this.AssetService = AssetService;
        this.fonts = $.extend({}, $builderService.getFonts());

        return {
            restrict: 'E',
            scope: {
            	"layer": "=",
            	"z": "=",
                "adunit": "=",
                "selectedEntity": "="
            },
            link: ($scope, $el, $attr) => {                
                                
                $scope.asset = $scope.adunit.assets[$scope.layer.assetId];
                this.calculateCss($scope, $el);

                $scope.$on('THUMBNAIL_GENERATED_' + $scope.layer.assetId, () => {
                    delete $scope.asset.generatingThumbnail;
                    this.render($scope, $el);
                });

            	$el.mousedown( (ev) => {
                    if(!$scope.layer.selected) {
                		ev.stopPropagation();
                		$scope.$emit("select-layer", $scope.layer);
                        this.$rootScope.$emit("select-layer", $scope.layer);
                        $scope.$apply();
                    }
            	});

                $scope.$watch("selectedEntity", (updated) => {

                    $scope.layer.selected = false;
                    $("ad-canvas-designer", "ad-builder").each( (c) => $(c).removeClass("selected") );

                    if(!!updated && !!$scope.layer) {
                        if($scope.layer.id === updated.id && $scope.layer.contentType === updated.contentType) {
                            $el.addClass("selected");
                            $el.closest("ad-canvas-designer").addClass("selected");
                            $scope.layer.selected = true;
                        }
                        else {
                            $el.removeClass("selected");
                        }
                    }
                    else {
                        $el.removeClass("selected");
                    }
                });

                if("undefined" !== typeof $scope.asset && "undefined" !== typeof $scope.asset.contentType) {
                    this.render($scope, $el);
	            }
                
                $rootScope.$on("feed-updated", () => {
                    this.render($scope, $el, true);
                });

                $rootScope.$on("render", () => {
                    this.render($scope, $el);
                });

                $scope.$watch('layer', (newitem, olditem) => {
                    $scope.asset = $scope.adunit.assets[$scope.layer.assetId];
                    this.calculateCss($scope, $el);                    
                    this.render($scope, $el);
                }, true);

                $scope.$watch("adunit.fonts", (newitem) => {
                    this.fonts = $.extend({}, $builderService.getFonts());
                    $.each(newitem, (k, v) => {
                        this.fonts[v.name] = "'" + v.name + "'";
                    });
                }, true);

                $scope.$watch("z", (newz) => {
                    $el.css("z-index", 400 - newz);
                });

                $rootScope.$on("feed-loaded", () => {
                    if($scope.asset.contentType.startsWith("x-reflow-widget")) {
                        this.render($scope, $el);
                    }
                });

            }

        };

    }

    render($scope, $el, forceRender) {

        var shouldRender = true;

        if(typeof forceRender === "undefined" || !forceRender) {

            if(!$scope.asset) {
                shouldRender = false;
            } else if(!!$el.data("busy-dragging")) {
                shouldRender = false;
            } else if(!!$scope.debounceTimer) {
                shouldRender = false;
            } else if(!!$scope.lastLayer) {

                if(JSON.stringify($scope.lastLayer) == JSON.stringify($scope.layer)) {
                     shouldRender = false;
                } else {
                    let d = diff($scope.layer, $scope.lastLayer);
                    let d2 = _.omit(d, ["top", "left", "selected", "behaviours", "templateVars"])
                    if(Object.keys(d2).length === 0) {
                        shouldRender = false;
                    }
                }
            }
        }

        if(shouldRender) {
            
            $scope.debounceTimer = window.setTimeout( () => {                 
                delete $scope.debounceTimer;
                this.render($scope, $el);
            }, 500);

            $scope.lastLayer = JSON.parse(JSON.stringify($scope.layer));

            let model = { };

            if("undefined" !== typeof REFLOW_DYNAMIC) {
                model.REFLOW_DYNAMIC = REFLOW_DYNAMIC;
            }

            let fn = RENDERERS[$scope.asset.contentType];
            if("function" === typeof fn) {
                let markup = fn($scope.layer, $scope.adunit);
                if("string" === typeof markup || "undefined" === typeof markup.done) {
                    $el.html(Mustache.render(markup, model));
                }
                else {
                    markup.done( (tpl) => {
                        let deferredMarkup = Mustache.render(tpl, model);
                        $el.html(deferredMarkup);
                    });
                }
            }
            else {
                $el.html($scope.layer.src);
            }

            if($scope.layer.autoFix) {
                let $child = $("> .text-div", $el);
                if($child.length > 0) {
                    $child.css({"max-width": "100%", "visibility": "hidden"});
                    var self = this;
                    window.setTimeout(function() {
                        self.adjustHeight($child, $scope);
                    }, 0);
                }
            }

            if(!!$scope.layer.textVerticalAlign) {
                let $child = $("> .text-div", $el);
                if($child.length > 0) {
                    switch($scope.layer.textVerticalAlign) {
                        case "middle": 
                            $child.css({"top": "50%", "transform": "translateY(-50%)"});
                            break;
                        case "bottom": 
                            $child.css({"top": "100%", "transform": "translateY(-100%)"});
                    }

                }
            }

            //Check if video asset has a thumbnail, if not set flag and re-render video element instead
            if(!!$scope.layer.shouldTriggerThumbnailGeneration) {
                $scope.layer.shouldTriggerThumbnailGeneration = false;
                this.AssetService.generateVideoThumbnail($scope.layer.assetId);
            }

        }

    }

    applyAdditionalCSS(el, $scope, contentType) {
        if(contentType === "text/plain") {
            if(!!$scope.layer.textVerticalAlign) {
                switch($scope.layer.textVerticalAlign) {
                    case "middle": 
                            el.css({"top" : "50%", "transform" : "translateY(-50%)"});
                        break;
                    case "bottom":
                            el.css({"top" : "75%", "transform" : "translateY(-75%)"});
                        break;
                }
            }
        }
    }
    
    adjustHeight(el, $scope) {

        let h = el.height();
        var looping = false;
        if(h > el.parent().height()) {
            var f = el.css("font-size");
            if(!!f) {
                f = parseFloat(f.match(/\d+/)[0]) * 0.95;
                if(f > $scope.layer.autoFixMinFont) {
                    el.css("font-size", f + "px");
                    var self = this;
                    window.setTimeout(function() {
                        self.adjustHeight(el, $scope);
                    }, 0);
                    looping = true;
                }
                else {
                    el.css("font-size", $scope.layer.autoFixMinFont + "px");
                }
            }
        }
        
        if(!looping) {
            el.css("visibility", "visible");
        }

    }

    calculateCss($scope, $el) {

        let css = {
            display: ($scope.layer.visible && $scope.layer.visibleInDesigner) ? 'block' : 'none',
            top: $scope.layer.top,

            left: $scope.layer.left,
            width: $scope.layer.width,
            height: $scope.layer.height,            
            "z-index": 400 - parseInt($scope.z)
        };

        if(!!$scope.layer.colour) {
            css.color = $scope.layer.colour;
        }
        else {
            css.color = "";
        }

        if(!!$scope.layer.padding) {
            css.padding = $scope.layer.padding + "px";
        }

        if(!!$scope.layer.backgroundColour) {
            css["background-color"] = $scope.layer.backgroundColour;
        }
        else {
            css["background-color"] = "";
        }

        //If the scope has a text div and VerticalAlign set...
        // console.log(textDiv);
        // if(!!textDiv && !!$scope.layer.textVerticalAlign) {
        //     if($scope.layer.textVerticalAlign == 'middle') {
        //         $("#layer-' + $scope.layer.id").find("text-div").css({"color": "orange", "border": "2px solid red"});
        //     }
        // }

        if(!!$scope.layer.borderStyle && $scope.layer.borderStyle !== "none") {
            var border = "";
            if(!!$scope.layer.borderWidth) {
                if(/^\d+$/.test($scope.layer.borderWidth)) {
                    border += $scope.layer.borderWidth + "px";
                }
                else {
                    border += $scope.layer.borderWidth;
                }
            }
            else {
                border += "1px";
            }

            border += " " + $scope.layer.borderStyle;
            
            if(!!$scope.layer.borderColour) {
                border += " " + $scope.layer.borderColour;
            }
            else {
                border += " black";
            }

            css.border = border;

        }
        else {
            css.border = "";            
        }

        if("undefined" !== typeof $scope.layer.borderRadius && $scope.layer.borderRadius > 0) {
            css["border-radius"] = $scope.layer.borderRadius;
        }
        else {
            css["border-radius"] = "";
        }

        if(!!$scope.layer.fontFamily) {
            css["font-family"] = this.fonts[$scope.layer.fontFamily];
        }
        else {
            css["font-family"] = "";
        }

        if(!!$scope.layer.fontSize) {
            if(/^\d+$/.test($scope.layer.fontSize)) {
                css["font-size"] = $scope.layer.fontSize + "px";
            }
            else {
                css["font-size"] = $scope.layer.fontSize;
            }
        }
        else {
            css["font-size"] = "";
        }

        if(!!$scope.layer.bold) {
            css["font-weight"] = "bold";
        }
        else {
            css["font-weight"] = "";
        }

        if(!!$scope.layer.italic) {
            css["font-style"] = "italic";
        }
        else {
            css["font-style"] = "";
        }

        if(!!$scope.layer.decoration && $scope.layer.decoration !== "none") {
            css["text-decoration"] = $scope.layer.decoration;
        }
        else {
            css["text-decoration"] = "";
        }

        if(!!$scope.layer.textAlign) {
            css["text-align"] = $scope.layer.textAlign;
        }
        else { 
            css["text-align"] = "";
        }

        if(!!$scope.layer.textDirection) {
            css.direction = $scope.layer.textDirection;  
        }

        if(!!$scope.layer.textTransform) {
            css["text-transform"] = $scope.layer.textTransform;
        }

        if(!("undefined" == typeof $scope.layer.opacity || $scope.layer.opacity === null)) {
            css.opacity = $scope.layer.opacity;
        }
        else {
            css.opacity = "";
        }

        if(!!$scope.layer.lineHeight && $scope.layer.lineHeight.length > 0) {
            css["line-height"] = $scope.layer.lineHeight;
        }
        else {
            css["line-height"] = "";
        }

        var transform = "";

        if(!!$scope.layer.scaleX) {
            transform += " scaleX(" + $scope.layer.scaleX + ")";
        }

        if(!!$scope.layer.scaleY) {
            transform += " scaleY(" + $scope.layer.scaleY + ")";
        }
        else {
            transform += " scaleY(1)";
        }

        if(!!$scope.layer.skewX) {
            transform += " skewX(" + $scope.layer.skewX + "deg)";
        }

        if(!!$scope.layer.skewY) {
            transform += " skewY(" + $scope.layer.skewY + "deg)";
        }

        if(!!$scope.layer.rotationX) {
            transform += " rotateX(" + $scope.layer.rotationX + "deg)";
        }

        if(!!$scope.layer.rotationY) {
            transform += " rotateY(" + $scope.layer.rotationY + "deg)";
        }

        if(!!$scope.layer.rotationZ) {
            transform += " rotateZ(" + $scope.layer.rotationZ + "deg)";
        }

        if(transform.length > 0) {
            css.transform = transform;
        }
        else {
            css.transform = "";
        }

        $el.css(css);

        $el.attr("class", "");
        if(!!$scope.layer.cssClasses) {
            $scope.layer.cssClasses.split(/[ ,]/).forEach( (cls) => {
                $el.addClass(cls);
            });
        }

    }

}

angular.module('cpm')
    .directive('adLayerDesigner', ["$rootScope", "$builderService", "AssetService", ($rootScope, $builderService, AssetService) => {
	    'use strict';
	    return new AdLayer($rootScope, $builderService, AssetService);
	}]);
